module.exports = __webpack_public_path__ + "assets/img/2476.922fcb25.png";